import { FeatureInterface } from '../models';

import {
  FeatureControlActions,
  FeatureControlActionType,
  LoadFeaturesCompleted,
  LoadFeaturesFailed,
} from './actions';
import { FeatureStateInterface } from './models/feature-state.model';

const initialState: FeatureStateInterface = {
  features: undefined,
  loaded: false,
  loading: false,
  error: undefined,
};

export function featureControlReducer(
  state: FeatureStateInterface = initialState,
  action: FeatureControlActions
): FeatureStateInterface {
  switch (action.type) {
    case FeatureControlActionType.LoadFeatures:
      return {
        ...state,
        loading: true,
        error: undefined,
      };

    case FeatureControlActionType.LoadFeaturesCompleted:
      const features: FeatureInterface[] = (action as LoadFeaturesCompleted)
        .payload;
      return {
        ...state,
        features,
        loaded: true,
        loading: false,
      };

    case FeatureControlActionType.LoadFeaturesFailed:
      const error: string = (action as LoadFeaturesFailed).payload;
      return {
        ...state,
        loaded: false,
        loading: false,
        error,
      };

    default:
      return state;
  }
}
